

























































































































import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import {
  ApplyWithdrawPass,
  FirstApplyWithdrawPass,
  ApplyWithdrawReject,
  QueryShopBalance,
  OpenNoPwdWithdrawal,
  QueryShopBalanceRecordList,
  QueryShopWealthDetail,
  ExportShopBalanceRecord,
  QueryWithdrawOrderById,
  RefreshWithdrawOrder
} from '@/api'
import { ElForm } from 'element-ui/types/form'
import { HuifuAcctTypeFormat, HuifuAcctStatFormat } from '@/utils/tyepconvert'
import BalancePayDialog from './BalancePayDialog.vue'
import LLpayWithdrawConfirmDialog from './LLpayWithdrawConfirmDialog.vue'
import {PriceFormat} from '@/utils/tyepconvert'
import { DateFormat } from '@/utils/date/DateUtil'

@Component({
  components: {
    BalancePayDialog,
    LLpayWithdrawConfirmDialog
  }
})
export default class WithdrawAuditDialog extends Vue {
  private show = false
  private data: any = { withdrawAmount: '', bankCardId: '' }
  private requiredRule = {
    required: true,
    message: '不能为空',
    trigger: 'blur'
  }
  private rules = {
    newPassword: [this.requiredRule]
  }

  private HuifuAcctTypeFormat = HuifuAcctTypeFormat
  private HuifuAcctStatFormat = HuifuAcctStatFormat
  private DateFormat = DateFormat
  private PriceFormat = PriceFormat
  private activeTabs = "p2"
  private withdrawRejectMsg = ''
  private auditNote = ''
  private balanceList = []
  private recordList = []
  private recordPagParam = {
    startRow:0,
    page:1,
    limit: 10,
    total: 0,
  }
  private loading = false
  private loadingRecord = false
  private loadingShopInfo = false
  private withdrawChannel = 'huifu'
  private shopInfo={shopName:""} //店铺信息

  @Emit('close')
  private close() {
    const f = this.$refs.form as ElForm
    f.resetFields()
    this.show = false
    this.data = { withdrawAmount: 0, feeAmount: 0, bankCardId: '' }
    this.balanceList = []
    this.shopInfo = {shopName:""}
    this.loadingShopInfo = false
    this.loading = false
    this.loadingRecord = false
  }

  @Emit('success')
  private success() {
    // 触发
  }

  private get withdrawAmount() {
    if (this.data.withdrawAmount) {
      return this.data.withdrawAmount - this.data.feeAmount
    }
    return 0
  }

  // 是否初次审核
  private get isFirstAudit() {
    if (this.data.withdrawStatus == 7 || this.data.withdrawStatus == 6) {
      return false
    }
    return true
  }

  // 余额不足
  private get balanceDefi() {
    if (
      this.withdrawChannel == 'huifu' &&
      this.huifuBalacne >= this.withdrawAmount
    ) {
      return false
    } else if (
      this.withdrawChannel == 'llpay' &&
      this.llpayBalacne >= this.data.withdrawAmount
    ) {
      // 连连需要满足全额
      return false
    }
    return true
  }

  // 汇付余额
  private get huifuBalacne() {
    const ts: any = this.balanceList.filter(
      (e: any) => e.acct_type == '01' && e.channel_name == '汇付支付'
    )
    if (ts.length > 0) {
      return Math.round(ts[0].avl_bal * 100)
    }
    return 0
  }
  // 是否查询到连连数据
  private get haveHuifuBalacne(){
    const ts: any = this.balanceList.filter(
      (e: any) => e.channel_name == '汇付支付'
    )
    if(ts && ts.length > 0){
      return true
    }
    return false
  }

  // 是否查询到连连数据
  private get haveLlpayBalacne(){
    const ts: any = this.balanceList.filter(
      (e: any) => e.channel_name == '连连支付'
    )
    if(ts && ts.length > 0){
      return true
    }
    return false
  }
  // 连连余额
  private get llpayBalacne() {
    const ts: any = this.balanceList.filter(
      (e: any) => e.channel_name == '连连支付'
    )
    if (ts.length > 0) {
      // 汇总
      let total = 0
      for (const i of ts) {
        // 可用余额账户
        if (i.acct_type == 'USEROWN_AVAILABLE') {
          total += Math.round(i.avl_bal * 100)
        }
      }
      return total
    }
    return 0
  }
  // 连连-待结算余额
  private get llpayPsettleBalacne() {
    const ts: any = this.balanceList.filter(
      (e: any) => e.channel_name == '连连支付'
    )
    if (ts.length > 0) {
      // 汇总
      let total = 0
      for (const i of ts) {
        // 可用余额账户
        if (i.acct_type == 'USEROWN_PSETTLE') {
          total += i.avl_bal * 100
        }
      }
      return total
    }
    return 0
  }

  private refreshCode(){
    // 刷新订单编号
    this.$confirm('是否确认刷新提现单号【'+this.data.withdrawCode+'】？注意：只有审核通过时提示：“出金核心返回，某些数据不符合唯一性要求”的时候才使用', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          RefreshWithdrawOrder({withdrawCode:this.data.withdrawCode}).then(res=>{
            // 刷新
            this.loadWithdrawDetail()
            // 刷新外面的列表
            this.success()
          })
        })
    

  }

  public open(data: any) {
    this.show = true
    this.data = {...data}
    this.loadWithdrawDetail()
    this.loadShopInfoFowWithdraw()
    this.loadBalance()
    this.loadRecord()
  }

  private loadingDetail = false
  private loadWithdrawDetail(){
    this.loadingDetail =  true
    QueryWithdrawOrderById({id:this.data.id}).then(res=>{
      if(res){
        this.data  = res
      }
      this.loadingDetail = false
    }).catch(e=>{
      this.loadingDetail = false
    })
  }

  private openBalancePayDialog(payChannelMerhant: string) {
    const d = this.$refs.BalancePayDialog as BalancePayDialog
    d.open({
      ...this.data,
      huifuBalacne: this.huifuBalacne,
      llpayBalacne: this.llpayBalacne,
      payChannelMerhant: payChannelMerhant
    })
  }

  private outShopIdFormat(v: any){
    if(v == '0'){
      return "平台/直营店铺"
    }
    return v
  }
  // 分页导航改变
  public recordPageChange(index: number) {
    this.recordPagParam.page = index
    this.loadRecord()
  }

  public recordSizeChange(index: number) {
    this.recordPagParam.page = 1
    this.recordPagParam.limit = index
    this.loadRecord()
  }

  private loadShopInfoFowWithdraw(){
    // 查询店铺信息
    this.loadingShopInfo = true
    QueryShopWealthDetail({id:this.data.shopId}).then(res=>{
      this.shopInfo = res
      this.loadingShopInfo = false
    }).catch(()=>{
      this.loadingShopInfo = false
    })
  }

  private exportBalanceData(){
    // 余额转账记录导出
    if(!this.data.shopId){
      this.$message.error("店铺ID不存在")
      return
    }
    const loading = this.$loading({
        lock: true,
        text: '正在导出余额转账记录',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    ExportShopBalanceRecord({inShopId: this.data.shopId},this.shopInfo.shopName+"-余额转账记录.xlsx").then(res=>{
      loading.close()
    }).catch(()=>{
      loading.close()
    })

  }

  private loadRecord(){
    this.loadingRecord = true
    console.log(this.recordPagParam.page)
    const param =  {inShopId: this.data.shopId,startRow:0,limit: 10}
    param.limit = this.recordPagParam.limit
    param.startRow = (this.recordPagParam.page - 1) * param.limit
    console.log(param.startRow)
    QueryShopBalanceRecordList(param).then(res=>{
      this.recordList = res.list
      this.recordPagParam.total = res.total
      this.loadingRecord = false
    }).catch(()=>{
      this.$message.error("查询失败")
      this.loadingRecord = false
    })
  }

  private loadBalance() {
    this.loading = true
    QueryShopBalance({ id: this.data.shopId })
      .then((res) => {
        this.balanceList = res
        this.loading = false
      })
      .catch(() => {
        this.$message.error('查询失败')
        this.loading = false
      })
  }

  public successAndClose() {
    this.close()
    this.success()
  }

  // 初审通过
  public async firtstPass() {
    this.loading = true
    try {
      const msg = '是否确认初审通过？'
        this.$confirm(msg, '提示', {
          type: 'warning'
        }).then(() => {
          FirstApplyWithdrawPass({
            id: this.data.id,
            auditNote:  this.auditNote
          }).then((res) => {
            if (res) {
              this.$message.success('提现初审通过，进行后续操作')
              this.close()
              this.success()
              this.loading = false
            }
          })
        })
    } finally {
      this.loading = false
    }
  }

  public async pass() {
    this.loading = true
    try {
      let n = '汇付支付'
      let openNoPwdWithdrawal = false // 是否开通免密提现
      if (this.withdrawChannel == 'llpay') {
        n = '连连支付'
        // 查询当前店铺，是否已经开通免密提现
        const isOpen = await OpenNoPwdWithdrawal({ id: this.data.shopId })
        if (isOpen) {
          openNoPwdWithdrawal = true
        }
      }
      if (this.withdrawChannel == 'llpay' && !openNoPwdWithdrawal) {
        // 输入提现密码进行提现
        const d = this.$refs.LLpayWithdrawConfirmDialog as any
        d.open(this.data)
      } else {
        const msg = '是否确认通过？通过后将从【' + n + '】出款'
        this.$confirm(msg, '提示', {
          type: 'warning'
        }).then(() => {
          ApplyWithdrawPass({
            id: this.data.id,
            withdrawChannel: this.withdrawChannel,
            auditNote:  this.auditNote
          }).then((res) => {
            if (res) {
              this.$message.success('提现审核通过，等待支付系统提现')
              this.close()
              this.success()
              this.loading = false
            }
          })
        })
      }
    } finally {
      this.loading = false
    }
  }

  public async reject() {
    if (!this.withdrawRejectMsg) {
      this.$message.error('请填写提现拒绝原因')
      return
    }
    this.$confirm('是否确认提现拒绝', '提示', {
      type: 'warning'
    }).then(() => {
      ApplyWithdrawReject({
        id: this.data.id,
        withdrawRejectMsg: this.withdrawRejectMsg,
        auditNote:  this.auditNote
      }).then((res) => {
        if (res) {
          this.$message.success('提现审核拒绝')
          this.close()
          this.success()
        }
      })
    })
  }
}
